import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient) {
  }

  getModel(modelId, referrer) {
    return this.http.get('https://api.repositorio.production.alquimio.cloud/api/modelos/indexado?modelId=' + modelId + '&referrer=' + referrer);
  }

}
